<template>
  <PDatePicker
    :model-value="modelValue"
    :label="campo.label"
    :error="Boolean(error)"
    :required="campo.obrigatorio"
    style="width: 100%"
    @update:model-value="(v: string) => emit('update:modelValue', v)"
  />
</template>

<script setup lang="ts">
import { PDatePicker } from "@f360-dev/f360-prisma";
import { TIntegracaoCampoModel } from "../../@types/IntegracaoCampoModel";

defineProps<{
  campo: TIntegracaoCampoModel;
  modelValue: string;
  error?: string;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: string): void;
}>();
</script>
